import { ReactElement, useEffect, useReducer } from 'react';
import useFeatureFlags from '@/src/Features/components/hooks/useFeatureFlags';
import { OVERRIDES_EVENT, WEB_V3_FLAG, isV3World } from './flags';

/*
 * World swap, mounted at the ENTRY routes only (/home, /activations,
 * /activations/:id, ...): renders the classic or v3 world in place.
 * Inside the v3 world, navigation uses v3's own canonical routes;
 * unbuilt areas bridge out to classic URLs (see flags.ts).
 * Authenticated routes only — the flag lookup rides the account session.
 */
export default function V3Swap({
    classic,
    v3,
}: {
    classic: ReactElement;
    v3: ReactElement;
}) {
    const { featureFlags } = useFeatureFlags();
    const [, bump] = useReducer((x: number) => x + 1, 0);

    useEffect(() => {
        const onChange = () => bump();
        window.addEventListener(OVERRIDES_EVENT, onChange);
        window.addEventListener('storage', onChange);
        return () => {
            window.removeEventListener(OVERRIDES_EVENT, onChange);
            window.removeEventListener('storage', onChange);
        };
    }, []);

    return isV3World(!!featureFlags[WEB_V3_FLAG]) ? v3 : classic;
}
